import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import prettyJoin from './pretty-joiner'


function handleEmptyReference(filter, labels, hasEmptyReferences) {
	let deletedValue = i18n.get('common.deletedItem')
	if (hasEmptyReferences()) {
		labels.push(deletedValue)
		filter.valid = false
	}
}

function handleInvalidValuesProperty(filter, labels) {
	//add in "deleted" for all the invalid ones
	let deletedValue = i18n.get('common.deletedItem')
	_.each(filter.invalidValues, () => { labels.push(deletedValue) })
	if (_.get(filter.invalidValues,'length',0) > 0) {
		filter.valid = false
	}
}

var PrettyId = function(filter, toLabel) {
	filter.valid = true
	if (filter.anyValue) {
		return i18n.get(filter.anyValueLabelCode)
	}
	var labels = []
	var meta = filter.metadata || {}
	var values = _.difference(filter.values, filter.invalidValues)
	let postLabel = ''

	if (_.isFunction(toLabel)) {
		labels = toLabel(values)
	} else {
		//find the labels for all the valid values
		_.each(values, function (value) {
			var label = _.result(meta[value] || value, 'label')
			postLabel = _.result(meta[value] || value, 'postLabel') || ''
			if (label) {
				labels.push(prettyJoin(label) + postLabel)
			}
		})
	}

	//handle no references
	handleEmptyReference(filter, labels, () => {
		return labels.length == 0 && (values.length == 0 || meta.invalid)
	})
	handleInvalidValuesProperty(filter, labels)

	let opCode = 'report.filter.pretty.multichoice'
	if (filter.operator == 'contains-all') {
		opCode = 'report.filter.pretty.set.containsAll'
	}

	return i18n.get(opCode, _.join(labels, ', '))
}

PrettyId.handleEmptyReference = handleEmptyReference

export default PrettyId
export { handleInvalidValuesProperty }
PrettyId.__filename__ = 'reports/common/filter/pretty-id.js'
